export const FAILED = 'ForgotPassword/failed';
export const LOADING = 'ForgotPassword/loading';
